'use client';

import { MyEquipmentHeader } from 'components/pcc-components';
import { useMyEquipmentDrawer } from '../my-equipment-drawer-context';

export const SelectEquipmentDrawerHeader = ({
  title,
  showBackArrow
}: {
  title: string;
  showBackArrow: boolean;
}) => {
  const {
    selectEquipmentDrawer: { closeDrawer, isChild }
  } = useMyEquipmentDrawer();
  return (
    <MyEquipmentHeader
      variant={'title-sm'}
      className="d-flex"
      onBackButtonClick={isChild && showBackArrow ? closeDrawer : null}
    >
      <span>{title}</span>
    </MyEquipmentHeader>
  );
};
